/* Opens the store credit info dialog from any [data-lt-credit-open] button (product page and cart drawer,
   which is re-rendered, so clicks are delegated). Clicking the backdrop closes the dialog. */
(() => {
  const dialog = () => document.getElementById('LtCreditDialog');
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-lt-credit-open]');
    const d = dialog();
    if (opener && d && typeof d.showModal === 'function') {
      event.preventDefault();
      d.showModal();
      return;
    }
    if (d && event.target === d) d.close();
  });
})();
